import { render, staticRenderFns } from "./IconMenuAlt3Solid.vue?vue&type=template&id=6a92408d"
import script from "./IconMenuAlt3Solid.vue?vue&type=script&lang=js"
export * from "./IconMenuAlt3Solid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports